import { __extends } from "tslib";
import React from 'react';
import { createPortal } from 'react-dom';
import ModalHelper from '@singularsystems/neo-core/dist/Components/Modal/ModalHelper';
var ModalPortal = /** @class */ (function (_super) {
    __extends(ModalPortal, _super);
    function ModalPortal(props) {
        var _this = _super.call(this, props) || this;
        _this.modalContainer = document.createElement("div");
        return _this;
    }
    ModalPortal.prototype.componentDidMount = function () {
        var options = this.props.options;
        this.modalInstance = ModalHelper.appInstance.addModal(this.modalContainer, options, options.showCancelButton !== false ? this.props.onDismiss : undefined);
    };
    ModalPortal.prototype.componentWillUnmount = function () {
        ModalHelper.appInstance.endRemove(this.modalInstance);
    };
    ModalPortal.prototype.render = function () {
        if (!this.props.show && !this.modalInstance.isRemoving) {
            ModalHelper.appInstance.beginRemove(this.modalInstance);
        }
        return createPortal(this.props.children, this.modalContainer);
    };
    return ModalPortal;
}(React.Component));
export default ModalPortal;
